import { render } from "./Timetable.vue?vue&type=template&id=5194df98"
import script from "./Timetable.vue?vue&type=script&lang=js"
export * from "./Timetable.vue?vue&type=script&lang=js"

import "./Timetable.vue?vue&type=style&index=0&id=5194df98&lang=css"
script.render = render

export default script